import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Campaign } from '~/api/models/campaign';
import StatsWidget from '@rio-cloud/rio-uikit/StatsWidget';
import StatsWidgetNumber from '@rio-cloud/rio-uikit/StatsWidgetNumber';
import StatsWidgets from '@rio-cloud/rio-uikit/StatsWidgets';
import {
  useGetCampaignStatisticsQuery,
  useLazyGetStageStatisticsQuery
} from '~/api/campaignStatistics/CampaignStatistics.api';
import StageSelect from '~/features/campaigns/components/StageSelect';
import CampaignStatisticsBody from '~/features/campaigns/components/CampaignStatisticsBody';
import { ALL } from '~/features/base/constants/filterOptions';
import NotFoundState from '@rio-cloud/rio-uikit/NotFoundState';
import ContentLoader from '@rio-cloud/rio-uikit/ContentLoader';
import { useHistory, useLocation } from 'react-router-dom';
import { STAGES_PATH } from '~/features/base/constants/routes';

interface CampaignStatusProps {
  campaign?: Campaign;
}


const CampaignStatus: React.FC<CampaignStatusProps> = ({ campaign }) => {
  const [selectedStage, setSelectedStage] = useState<string>(ALL);
  const history = useHistory();
  const location = useLocation();

  const openTab = (installationStatus?: string) => {
    const newQuery: any = {};
    if (installationStatus) {
      newQuery.installationStatus = installationStatus;
    }
    newQuery.stage = selectedStage === ALL ? ALL : campaign?.stages.find(s => s.id === parseInt(selectedStage))?.stageOrder;
    const searchParams = new URLSearchParams(newQuery).toString();
    const pathParts = location.pathname.split('/');
    const campaignId = pathParts[2];
    const stagesPath = `/campaigns/${campaignId}/${STAGES_PATH}${searchParams ? `?${searchParams}` : ''}`;
    history.push(stagesPath);
  };

  const { data: campaignStatistics, isLoading: campaignLoading } = useGetCampaignStatisticsQuery(
    campaign?.id!,
    { skip: !campaign?.id || selectedStage !== ALL }
  );

  const [getStageStatistics, { data: stageStatistics, isLoading: stageLoading }] = useLazyGetStageStatisticsQuery();

  const statistics = selectedStage === ALL ? campaignStatistics?.stageStatistics : stageStatistics?.stageStatistics;
  const isLoading = campaignLoading || stageLoading;

  const handleStageChange = (stageId: string) => {
    setSelectedStage(stageId);
    if (stageId !== ALL) {
      const stageIdNum = parseInt(stageId);
      if (!isNaN(stageIdNum)) {
        getStageStatistics(stageIdNum);
      }
    }
  };

  return (
    <div className='border-color-lighter padding-20 border-radius-5 border-width-1 border-style-solid'>
      <div className='display-flex justify-content-between align-items-center margin-bottom-15'>
        <h4 className='margin-0'>Status</h4>
        <StageSelect
          campaign={campaign}
          selectedStage={selectedStage}
          onStageChange={handleStageChange}
        />
      </div>
      {(statistics || isLoading) && (
        <StatsWidgets>
          <StatsWidget style={{ border: 'none' }}>
              <StatsWidget.Header>
                                      <span className={'text-size-h5 text-bold'} style={{ fontFamily: 'MANEUROPECONDENSED' }}>
                        <FormattedMessage id={'intl-msg:campaign:statistics:targetVehicles'}/>
                    </span>
                  <StatsWidget.Body>
                    {!isLoading ? <StatsWidgetNumber value={statistics?.targetNumber}/> :
                        <ContentLoader width={'20%'}/>
                    }

                  </StatsWidget.Body>
              </StatsWidget.Header>
            <StatsWidget.Body>
              <CampaignStatisticsBody statistics={statistics} isLoading={isLoading} openTab={openTab}/>
            </StatsWidget.Body>
          </StatsWidget>
        </StatsWidgets>
      )}
      {!statistics && !isLoading && (
        <div className='height-75pct'>
          <NotFoundState
            fullWidth
            outerClassName={'border-none'}
            headline={<FormattedMessage id='intl-msg:campaign:status:noStatusAvailable'/>}
          />
        </div>
      )}
    </div>
  );
};

export default CampaignStatus;
